<dx-popup
  [width]="400"
  height="auto"
  class="history-form-popup"
  [showTitle]="true"
  title="Historique"
  [deferRendering]="false"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <dx-form class="history-form" #form [formData]="request">

      <dxi-item dataField="tractor" editorType="dxSelectBox" [label]="{text: 'Tracteur'}"
                [editorOptions]="{width: '100%', dataSource: tractors, displayExpr: 'name',
                              placeholder: 'Tracteur',
                              searchMode: 'contains',
                              searchExpr : ['name', 'domain_name', 'id'],
                              searchEnabled:true}">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item dataField="currentFilter" editorType="dxSelectBox" [label]="{text: 'Filter'}"
                [editorOptions]="{width: '100%', items: dateFilters, displayExpr: 'label',
                              valueExpr: 'value', placeholder: 'Filter',
                              onValueChanged: dateFilterChanged}"></dxi-item>

      <dxi-item dataField="from" editorType="dxDateBox" [label]="{text: 'Date Début'}"
                [editorOptions]="{width: '100%', placeholder: 'Date Début',
                              type: 'datetime', onValueChanged: dateChanged}"
                [visible]="request.currentFilter == 0">
        <dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>

      <dxi-item dataField="to" editorType="dxDateBox" [label]="{text: 'Date Fin'}"
                [editorOptions]="{width: '100%', placeholder: 'Date Fin', type: 'datetime',
                              min: request.from, onValueChanged: dateChanged}"
                [visible]="request.currentFilter == 0">
        <dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>

      <dxi-item dataField="minStopDuration" editorType="dxSelectBox" [label]="{text: 'Arrêts'}"
                [editorOptions]="{width: '100%', value: 60, items: stops, displayExpr: 'label',
                              valueExpr: 'value', placeholder: 'Arrêts'}"></dxi-item>
    </dx-form>
  </div>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            stylingMode: 'contained',
            type: 'default',
            text: 'Afficher',
            onClick: requestSubmit
        }">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            stylingMode: 'contained',
            text: 'Annuler',
            type: 'normal',
            onClick: requestCancel
        }">
  </dxi-toolbar-item>
</dx-popup>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.history-form' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
